import api from '../api';

// MIGRATION: Independent agents now use the unified /quotes endpoints.
// The unified `quotes` table uses different field names than the legacy
// independent_quotes table (title vs trip_name, travel_start_date vs
// start_date, travel_end_date vs end_date, total_amount vs total_price).
// These adapters translate in both directions so the existing Independent
// quote builder/list UI (which still uses the legacy field names) keeps
// working unchanged.

const toUnifiedQuote = (quoteData) => {
  const {
    trip_name, start_date, end_date, total_price,
    ...rest
  } = quoteData;

  const mapped = { ...rest };
  if (trip_name !== undefined) mapped.title = trip_name;
  if (start_date !== undefined) mapped.travel_start_date = start_date;
  if (end_date !== undefined) mapped.travel_end_date = end_date;
  if (total_price !== undefined) mapped.total_amount = total_price;

  return mapped;
};

const fromUnifiedQuote = (quote) => {
  if (!quote || typeof quote !== 'object') return quote;

  return {
    ...quote,
    trip_name: quote.title,
    start_date: quote.travel_start_date,
    end_date: quote.travel_end_date,
    total_price: quote.total_amount
  };
};

export const independentQuotesService = {
  getAll: async () => {
    const response = await api.get('/quotes');
    return Array.isArray(response.data) ? response.data.map(fromUnifiedQuote) : response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/quotes/${id}`);
    return fromUnifiedQuote(response.data);
  },

  create: async (quoteData) => {
    const response = await api.post('/quotes', toUnifiedQuote(quoteData));
    return response.data;
  },

  update: async (id, quoteData) => {
    const response = await api.put(`/quotes/${id}`, toUnifiedQuote(quoteData));
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/quotes/${id}`);
    return response.data;
  },

  send: async (id, emailData) => {
    const response = await api.post(`/quotes/${id}/send`, emailData);
    return response.data;
  },

  markAsSent: async (quoteId) => {
    const response = await api.put(`/quotes/${quoteId}/mark-sent`);
    return response.data;
  }
};

export default independentQuotesService;
